import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import ContentContainer from './ContentContainer';
import DetailsLink from './DetailsLink';
import { getApplicationViewData } from './util';
import { applicationConstants } from '../../../../constants/applicationConstants';
import EmployeeCell from '../EmployeeCell';

const CompleteContent = () => (
  <ContentContainer>
    {(items, user) => (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell>№ заявления</TableCell>
            <TableCell>Организация / ФИО</TableCell>
            <TableCell>Сколько осталось поездок</TableCell>
            <TableCell>Сколько всего поездок</TableCell>
            <TableCell numeric>Действие</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(application => {
            const { id, appNumber, userName, runsLeft, runsTotal } = getApplicationViewData(
              application,
              applicationConstants.STATUS_COMPLETE,
              user
            );
            return (
              <TableRow key={id}>
                <TableCell>{appNumber}</TableCell>
                <EmployeeCell userName={userName} application={application} />
                <TableCell>{runsLeft}</TableCell>
                <TableCell>{runsTotal}</TableCell>
                <TableCell numeric className="nowrap">
                  <DetailsLink user={user} item={application} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </React.Fragment>
    )}
  </ContentContainer>
);

export default CompleteContent;
